var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`stockTotalChange ${_vm.getCardClass}`},[_vm._v(_vm._s(_vm.totalChange))])
}
var staticRenderFns = []

export { render, staticRenderFns }